import { render } from 'preact';
import { defaultQueryOptions } from '@intrnl/rq';

import '~/styles/reset.css';
import '~/styles/app.css';
import { App } from '~/components/App';


defaultQueryOptions.errorBoundary = true;

render(<App />, document.getElementById('root'));
